import React from 'react'
import Dropdown from '../../dropdown/Dropdown'

const TableControllers = ({ date, scrollToLeft, scrollToRight, updateDate }) => {
  return (
    <>
      <div className="float-buttons">
        <div className="row-buttons">
          <button className="button-left" onClick={scrollToLeft}>
            <svg width="24" height="15" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" d="M1.3125 6.5C0.760215 6.5 0.3125 6.94772 0.3125 7.5C0.3125 8.05228 0.760215 8.5 1.3125 8.5V6.5ZM23.3946 8.20711C23.7851 7.81658 23.7851 7.18342 23.3946 6.79289L17.0306 0.428932C16.6401 0.0384078 16.007 0.0384078 15.6164 0.428932C15.2259 0.819457 15.2259 1.45262 15.6164 1.84315L21.2733 7.5L15.6164 13.1569C15.2259 13.5474 15.2259 14.1805 15.6164 14.5711C16.007 14.9616 16.6401 14.9616 17.0306 14.5711L23.3946 8.20711ZM1.3125 8.5H22.6875V6.5H1.3125V8.5Z" />
            </svg>
          </button>
          <button className="button-right" onClick={scrollToRight}>
            <svg width="24" height="15" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" d="M1.3125 6.5C0.760215 6.5 0.3125 6.94772 0.3125 7.5C0.3125 8.05228 0.760215 8.5 1.3125 8.5V6.5ZM23.3946 8.20711C23.7851 7.81658 23.7851 7.18342 23.3946 6.79289L17.0306 0.428932C16.6401 0.0384078 16.007 0.0384078 15.6164 0.428932C15.2259 0.819457 15.2259 1.45262 15.6164 1.84315L21.2733 7.5L15.6164 13.1569C15.2259 13.5474 15.2259 14.1805 15.6164 14.5711C16.007 14.9616 16.6401 14.9616 17.0306 14.5711L23.3946 8.20711ZM1.3125 8.5H22.6875V6.5H1.3125V8.5Z" />
            </svg>
          </button>
        </div>
      </div>

      <div className="nav-prog">
        <div className="col-dates">
          <Dropdown value={date} setValue={updateDate} options={['Hoy', 'Mañana']} />
        </div>
        
        <div className="col-hours">
          {
            [...Array(48).keys()].map((i) => {
              let number = parseInt(i / 2)
              number.toString().length === 1 && (number = `0${number}`)
              let hour = `${number}:00`
              i % 2 !== 0 && (hour = `${number}:30`)
            
              return (
                <div key={`col-hour-${i}`} className="col-hour">
                  <div className={`block-hour ${i === 47 ? 'noafter' : ''}`}>
                    <p>{hour}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  )
}

export default React.memo(TableControllers)
